import languageConst from '@/consts/language.const.js';
import instanceConst from '@/consts/instance.const.js';

export default {
  label: 'pix.pixName',
  instances: [],
  roles: '',
  requiresAuth: true,
  children: [
    {
      name: 'logout',
      hasSeparator: true,
    },
    {
      label: 'components.home.NavigationBarComponent.Help.Menu.TermsCond.Title',
      instances: [],
      roles: '',
      children: [
        {
          label: 'components.home.NavigationBarComponent.Help.Menu.TermsCond.Menu.TermsConditions',
          instances: [],
          roles: '',
          fn(scope) {
            scope.redirectToGea(`QDisclaimer/QDisclaimerDocument?VersionId=1&lang=${scope.$i18n.locale}`);
          },
        },
        {
          label: 'components.home.NavigationBarComponent.Help.Menu.TermsCond.Menu.PrivacyPolicy',
          instances: [],
          roles: '',
          fn(scope) {
            scope.redirectToGea(`QDisclaimer/QDisclaimerDocument?VersionId=2&lang=${scope.$i18n.locale}`);
          },
        },
        {
          label: 'components.home.NavigationBarComponent.Help.Menu.TermsCond.Menu.Cookies',
          instances: [],
          roles: '',
          fn(scope) {
            scope.redirectToGea(`QDisclaimer/QDisclaimerDocument?VersionId=3&lang=${scope.$i18n.locale}`);
          },
        },
      ],
    },
    {
      label: 'components.home.NavigationBarComponent.Help.Menu.Lang.Title',
      instances: [],
      roles: '',
      children: [
        {
          label: 'components.home.NavigationBarComponent.Help.Menu.Lang.Menu.EN',
          name: `lang-${languageConst.EN}`,
          instances: [],
          roles: '',
          fn(scope) {
            scope.changeLanguage(languageConst.EN);
          },
          imgSource: instanceConst.UK,
        },
        {
          label: 'components.home.NavigationBarComponent.Help.Menu.Lang.Menu.ES',
          name: `lang-${languageConst.ES}`,
          instances: [],
          roles: '',
          fn(scope) {
            scope.changeLanguage(languageConst.ES);
          },
          imgSource: instanceConst.ES,
        },
        {
          label: 'components.home.NavigationBarComponent.Help.Menu.Lang.Menu.PT',
          name: `lang-${languageConst.PT}`,
          instances: [],
          roles: '',
          fn(scope) {
            scope.changeLanguage(languageConst.PT);
          },
          imgSource: instanceConst.PT,
        },
        {
          label: 'components.home.NavigationBarComponent.Help.Menu.Lang.Menu.IT',
          name: `lang-${languageConst.IT}`,
          instances: [],
          roles: '',
          fn(scope) {
            scope.changeLanguage(languageConst.IT);
          },
          imgSource: instanceConst.IT,
        },
        {
          label: 'components.home.NavigationBarComponent.Help.Menu.Lang.Menu.FR',
          name: `lang-${languageConst.FR}`,
          instances: [],
          roles: '',
          fn(scope) {
            scope.changeLanguage(languageConst.FR);
          },
          imgSource: instanceConst.FR,
        },
        {
          label: 'components.home.NavigationBarComponent.Help.Menu.Lang.Menu.CH',
          name: `lang-${languageConst.CH}`,
          instances: [],
          roles: '',
          fn(scope) {
            scope.changeLanguage(languageConst.CH);
          },
          imgSource: instanceConst.CH,
        },
      ],
    },
  ],
};
